import {
  IconCheck,
  IconCloud,
  IconDatabase,
  IconDeviceLaptop,
  IconShieldCheck,
  IconShieldLock,
  IconTopologyStar3,
  IconUserShield,
  IconWorld,
  IconX,
} from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import type { NetworkNode, NodeType, RecommendedActionCode, RiskLevel } from "../../types";
import styles from "./nodeView.module.css";

export type NodeVerdict = "correct" | "partial" | "missed" | "falsePositive" | "ignored";

export const VERDICT_VIEW: Record<NodeVerdict, { icon: JSX.Element; label: JSX.Element }> = {
  correct: {
    icon: <IconShieldCheck size={15} aria-hidden="true" />,
    label: <Trans>Верно: риск и мера</Trans>,
  },
  partial: {
    icon: <IconCheck size={15} aria-hidden="true" />,
    label: <Trans>Риск верно, мера неточна</Trans>,
  },
  missed: { icon: <IconX size={15} aria-hidden="true" />, label: <Trans>Пропущен риск</Trans> },
  falsePositive: {
    icon: <IconX size={15} aria-hidden="true" />,
    label: <Trans>Ложное срабатывание</Trans>,
  },
  ignored: {
    icon: <IconCheck size={15} aria-hidden="true" />,
    label: <Trans>Верно (без риска)</Trans>,
  },
};

/** Scoring-independent classification of a node's marking for display. */
export function verdictFor(
  node: NetworkNode,
  marked: boolean,
  measure: RecommendedActionCode | undefined,
): NodeVerdict {
  if (node.isRisky) {
    if (!marked) {
      return "missed";
    }
    return measure === node.recommendedMeasure ? "correct" : "partial";
  }
  return marked ? "falsePositive" : "ignored";
}

const NODE_ICON: Record<NodeType, typeof IconWorld> = {
  public_site: IconWorld,
  admin_panel: IconShieldLock,
  database: IconDatabase,
  office_laptops: IconDeviceLaptop,
  vendor_access: IconUserShield,
  cloud_storage: IconCloud,
};

export function NodeIcon({ type, size = 16 }: { type: NodeType; size?: number }): JSX.Element {
  const Icon = NODE_ICON[type] ?? IconTopologyStar3;
  return <Icon size={size} aria-hidden="true" />;
}

/** Left-border risk tint class for a node card or chip. */
export const RISK_CLASS: Record<RiskLevel, string | undefined> = {
  low: styles.rLow,
  medium: styles.rMedium,
  high: styles.rHigh,
};
